// extracted by mini-css-extract-plugin
export default {"copyArea":"CodeCopyButton_copyArea__6ANrz","copyBtn":"CodeCopyButton_copyBtn__GqWj+","tooltip":"CodeCopyButton_tooltip__GYdMu","fadeIn":"CodeCopyButton_fadeIn__hQJ4t"};